import { ButtonPrimary } from 'components/Button'
import { AutoColumn } from 'components/Column'
import { RowBetween, RowFixed } from 'components/Row'
import styled, { keyframes } from 'styled-components'

export const PageWrapper = styled(AutoColumn)`
  max-width: 1400px;
  padding: 0 12px;
  width: 100%;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    max-width: 800px;
      padding: 0;
  `};

  ${({ theme }) => theme.mediaWidth.upToSmall`
    max-width: 500px;
        padding: 0;
  `};
`
export const TitleRow = styled(RowBetween)`
  color: ${({ theme }) => theme.text2};
  ${({ theme }) => theme.mediaWidth.upToSmall`
    flex-wrap: wrap;
    gap: 12px;
    width: 100%;
    flex-direction: column-reverse;
  `};
`
export const ButtonRow = styled(RowFixed)`
  & > *:not(:last-child) {
    margin-right: 8px;
  }
  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
  `};
`
export const NoLiquidity = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: auto;
  max-width: 300px;
  min-height: 25vh;
`
export const ResponsiveButtonPrimary = styled(ButtonPrimary)`
  border-radius: 12px;
  padding: 6px 8px;
  width: fit-content;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    flex: 1 1 auto;
    width: 49%;
  `};
`

export const MainContentWrapper = styled.main`
  background-color: ${({ theme }) => theme.bg0};
  padding: 8px;
  border-radius: 14px;
  display: flex;
  flex-direction: column;
`

export const PaginationContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 24px;
  margin-bottom: 24px;
  gap: 8px;
  justify-content: center;
  button {
    width: 46px;
  }
  span {
    font-size: 14px;
    font-weight: 500;
  }
`

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    grid-template-columns: repeat(2, 1fr); 
  `};

  ${({ theme }) => theme.mediaWidth.upToSmall`
    grid-template-columns: repeat(1, 1fr); 
  `};
`
export const TableWrapper = styled.table`
  width: 100%;
  max-width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 14px;
  overflow: hidden; /* Ensures the border-radius applies to the entire table */

  td {
    padding: 16px 12px;
    text-align: left;
  }

  th {
    background-color: ${({ theme }) => theme.bg1};
    font-weight: 600;
    color: #c3c5cb;
    padding: 16px 12px;
  }

  tr {
    transition: background-color 0.3s;
    &:hover {
      background-color: ${({ theme }) => theme.bg2};
    }
  }

  tbody tr {
    background-color: ${({ theme }) => theme.bg0};
  }
`

export const InputTextWrapper = styled.div`
  width: 100%;
  padding: 12px;
  background: ${({ theme }) => theme.bg0};
  border-radius: 14px;
  display: flex;
  gap: 12px;
  align-items: center;
  transition: all 300ms;
  &:hover {
    background: ${({ theme }) => theme.bg1};
  }
`

export const InputText = styled.input`
  all: unset;
  flex: 1;
`

export const CancelButton = styled.button`
  all: unset;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 2px;
  background: ${({ theme }) => theme.bg2};
  border-radius: 8px;
  transition: all 300ms;

  &:hover {
    background: ${({ theme }) => theme.bg3};
  }
`

export const GridContainerForCard = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;

  @media (max-width: 1080px) {
    grid-template-columns: 2fr;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

export const GridContainerForAllCard = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 24px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

export const LeverageItem = styled.div`
  border-radius: 14px;
  background: ${({ theme }) => theme.bg1};
  padding: 20px;
  animation: ${fadeIn} 0.5s ease-out;
  .responsive-text {
    @media (max-width: 768px) {
      font-size: 14px;
    }
  }
}
`

export const AllCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 14px;
  background: ${({ theme }) => theme.bg0};
  padding: 16px;
  animation: ${fadeIn} 0.5s ease-out;

  .pool-display-none-mobile {
    @media (max-width: 1180px) {
      display: none !important;
    }
  }

  .pool-display-block-mobile {
    @media (max-width: 1180px) {
      display: block;
    }
  }

  .pool-display-none-desktop {
    @media (min-width: 1180px) {
      display: none;
    }
  }

  .pool-display-block-desktop {
    @media (min-width: 1180px) {
      display: block;
    }
  }

  .responsive-text {
    @media (max-width: 1180px) {
      font-size: 14px !important;
    }
  }

  .card-wrapper-header {
    display: flex;
    align-items: center;
    margin-left: 30px;
    margin-bottom: 8px;

    @media (max-width: 1180px) {
      flex-direction: column;
      align-items: flex-start;
      margin-left: 0;
      .card-wrapper-logo {
        margin-left: 30px;
      }
      .card-wrapper-infos {
        display: flex;
        flex-wrap: wrap;
        gap: 18px;
        flex-direction: row;
        max-width: 100%;
        flex: unset;
        margin-top: 16px;

        div {
          width: unset !important;
        }
      }
    }

    .card-wrapper-logo {
      display: flex;
      align-items: center;
      gap: 8px;
      width: 250px;
    }

    .card-wrapper-infos {
      display: flex;
      flex: 1;
      align-items: center;

      position: relative;

      div {
        align-items: flex-start;
      }

      .wrapper-apr {
        width: 12%;
      }
      .wrapper-fees {
        width: 12%;
      }
      .wrapper-tvl {
        width: 17.5%;
      }
      .wrapper-volume {
        width: 17.5%;
      }
      .wrapper-reserve {
        width: 32%;
      }
      .wrapper-btn {
        width: 9%;
      }
    }
  }
`
